export { default as NotificationBar } from './component';
